// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetFoldersRequestModel from '../../model/get-folders-request-model';
import GetFoldersRequestDTO from '../dto/get-folders-request-dto';
import dtoSchema from '../schemas/get-folders-request-schema';

export default abstract class GetFoldersRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetFoldersRequestDTO>) {
    super();
    if (data) {
      this.entityType = data.entityType;
      this.entityId = data.entityId;
    }
  }
  /**
  */
  entityType?: string;
  /**
  * @type {int64}
  */
  entityId?: number;

  static toModel(dto: DeepPartial<GetFoldersRequestDTO>): GetFoldersRequestModel;
  static toModel(dto: DeepPartial<GetFoldersRequestDTO> | undefined | null): GetFoldersRequestModel | undefined;
  static toModel(dto: DeepPartial<GetFoldersRequestDTO> | undefined | null): GetFoldersRequestModel | undefined {
    return dto ? new GetFoldersRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetFoldersRequestModel> | GetFoldersRequestModel): GetFoldersRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      entityType: unwrapped.entityType,
      entityId: unwrapped.entityId,
    } as GetFoldersRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetFoldersRequestModel, can not map to GetFoldersRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
